import { Skeleton } from 'antd';
import CardBody from '../CardBody';
import CardContainer from '../CardContainer';
import classNames from 'classnames';
import styles from './index.module.scss';

const ProcessingDeadlineCardSkeleton = () => {
  return (
    <CardContainer
      className={classNames({
        [styles.card]: true,
      })}
    >
      <Skeleton.Input
        style={{ width: '100%', height: '180px', borderRadius: '4px' }}
        block
        active
        size="large"
      />

      <CardBody
        title={
          <div style={{ margin: '20px 0' }}>
            <Skeleton.Input style={{ width: '100%' }} active size="small" block />
            <div style={{ marginTop: 10 }}>
              <Skeleton.Input style={{ width: 300 }} active size="small" />
            </div>
          </div>
        }
      >
        <div className={styles.container}>
          {Array.from({ length: 7 }).map((_, i) => (
            <div
              key={i}
              className={styles.gridRow}
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr 1fr',
                gap: '5px',
                alignItems: 'center',
                padding: '2px 0',
              }}
            >
              <Skeleton.Input style={{ width: '100%' }} active size="small" block />
              <Skeleton.Input style={{ width: '100%' }} active size="small" block />
              <Skeleton.Input style={{ width: '100%' }} active size="small" block />
              <Skeleton.Input style={{ width: '100%' }} active size="small" block />
            </div>
          ))}
        </div>
      </CardBody>
    </CardContainer>
  );
};

export default ProcessingDeadlineCardSkeleton;
